// ##### 24-06-12 Komarov
import parse from 'html-react-parser';
import uniqueId from 'lodash.uniqueid';
// ##### Komarov 2025-08-26
import React, { useCallback } from 'react';
import { Media } from '../../../../../helpers/MediaConfig';
// ##### Komarov 2025-08-27
import { useSelector, useDispatch } from 'react-redux';
import { useLocalizedText } from '../../../../../hooks/useLocalizedText.js';
import { unsetDevMode } from '../../../../../Redux/actions';
// ##### 25-05-21 Komarov
import HomeLinkTag from '../../../../Library/Common/HomeLinkTag';
import LogInLinkTag from '../../../../Library/Common/LogInLinkTag';
import EmailIcon from '../../../../Library/Icons/email';
import Operations from '../../../../Library/Icons/operations';
import PhoneIcon from '../../../../Library/Icons/phoneicon';
import LocalizationNavLink from '../../../../Library/Localization/LocalizationNavLink';

// ##### Komarov 2025-07-14
const TopMenuRightDivPartForNotDesktop = () => {
  // ##### Komarov 2025-08-05
  const Operations_icon = useLocalizedText('Operations_icon');
  const Mail_icon = useLocalizedText('Mail_icon');
  const Phone_icon = useLocalizedText('Phone_icon');
  // ##### Komarov 2025-08-27
  const devMode = useSelector(state => state.devMode);

  const dispatch = useDispatch();
  const handleOutDev = useCallback(() => {
    localStorage.removeItem('devKey');
    // ##### Komarov 2025-08-26
    // Удаляем cookie devMode
    document.cookie = 'devMode=; Path=/; Max-Age=0';
    dispatch(unsetDevMode());
  }, [dispatch]);

  return (
    <div
      // ##### Komarov 2025-07-24
      data-component="TopMenuRightDivPartForNotDesktopSsr"
      className="topMenu_right_mobile"
    >
      <Media lessThan="Laptop-1024-1440">
        {/* ##### Komarov 2025-07-08 */}
        <EmailIcon
          key={uniqueId()}
          hintText={
            Mail_icon.includes('No translations for')
              ? 'Email'
              : parse(Mail_icon)
          }
        />
      </Media>
      <Media lessThan="Laptop-1024-1440">
        {/* ##### Komarov 2025-07-08 */}
        <PhoneIcon
          hintText={
            Phone_icon.includes('No translations for')
              ? 'Phone'
              : parse(Phone_icon)
          }
        />
      </Media>

      {/* ##### 23-04-05 Komarov: элемент Home */}
      <HomeLinkTag />

      {/* ##### 23-04-05 Komarov: элемент Operations */}
      { /* ##### Komarov 2025-07-24 */}
      <LocalizationNavLink key={uniqueId()} exact to={'/mybooking'}>
        <Operations key={uniqueId()} hintText={parse(Operations_icon)} />
        {/* ##### 24-03-21 Komarov */}
      </LocalizationNavLink>

      {/* ##### 23-11-01 Komarov */}
      <Media greaterThanOrEqual="Laptop-1024-1440">
        <LogInLinkTag right="9rem" />
        {/* ##### Komarov 2025-08-27: кнопка для выхода из режима Разработчика */}
        {devMode && (
          <button
            onClick={handleOutDev}
            style={{
              marginLeft: '10px',
              padding: '4px 8px',
              backgroundColor: '#ff4444',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '12px',
              fontWeight: 'bold',
            }}
          >
            outDev
          </button>
        )}
      </Media>
    </div>
  );
};

export default TopMenuRightDivPartForNotDesktop;
